import { Routes } from '@angular/router';
import { InfoPageComponent } from 'app/pages/info-page/info-page.component';
import { AdminGuard } from '../../core/guards/admin.guard.for.admin'
import { ClientGuard } from 'app/core/guards/client.guard';
import { RoleGuardSErvice } from 'app/core/guards/role.guard';
import { UserGuard } from 'app/core/guards/user.guard';
import { MENU } from 'app/common/constants';

const pages = MENU.map(m => ({
  path: m.name,
  loadChildren: () => import('../client-module/client-module.module').then(m => m.ClientModuleModule),
  canActivate: [ClientGuard],
}));

export const AdminLayoutRoutes: Routes = [
  { path: 'redirecting', component: InfoPageComponent },
  {
    path: 'user',
    loadChildren: () => import('../user-module/user-module.module').then(m => m.UserModuleModule),
    canActivate: [UserGuard]
  },
  {
    path: '',
    loadChildren: () => import('../client-module/client-module.module').then(m => m.ClientModuleModule),
    canActivate: [ClientGuard],
  } 
];
